export default "__VITE_ASSET__D3u7yPbQ__"